module.exports = __webpack_public_path__ + "static/media/lunas.e72435c9.png";